import { render, staticRenderFns } from "./RevolvingPutOptionPremiumPaymentsTable.vue?vue&type=template&id=646bc620&"
import script from "./RevolvingPutOptionPremiumPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./RevolvingPutOptionPremiumPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports